import { RootState } from 'store';
import minimumWagesAdapter from 'store/adapters/minimum-wages-adapter';

export const minimumWagesSelectors = minimumWagesAdapter.getSelectors((state: RootState) => state.minimumWages);
export const minimumWagesSelector = minimumWagesSelectors.selectAll;

export const minimumWagesLoadingSelector = (state: RootState): boolean => state.minimumWages.loading;
